import { NgModule, OnInit, Directive } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyAccountComponent } from './my-account.component';
import { RouterModule } from '@angular/router';
import { AccountDashboardComponent } from 'src/app/modules/account-dashboard/account-dashboard.component';
import { MyCoursesComponent } from 'src/app/modules/my-courses/my-courses.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TeacherCommentsComponent } from 'src/app/modules/teacher-comments/teacher-comments.component';

@NgModule({
  declarations: [
    MyAccountComponent,
    AccountDashboardComponent,
    MyCoursesComponent,
    TeacherCommentsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class MyAccountModule implements OnInit {
    ngOnInit(){
    }

 }
